import axios from "axios";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { Card, CardBody, Input, Table } from "reactstrap";
import { ServiceThreadSpinner, SortHeader } from ".";
import { api, constants, dateHelpers } from "../utils";

export default function InventoryDashBoardVarianceGrid(props) {
   const {
      selectedItem,
      typeOfDataSource,
      invVarSortDirection,
      invVarSortField
   } = props.params;

   const [data, setData] = useState([]);
   const [includeLabels, setLWC] = useState(false);
   const [loaded, setLoaded] = useState(false);
   const [params, setParams] = useState({});
   const payload = {
      ItemNumber: selectedItem?.value,
      TypeOfSource: typeOfDataSource,
      InvVarSortDirection: invVarSortDirection,
      InvVarSortField: invVarSortField,
      IncludeLWC: includeLabels
   }

   useEffect(() => {
      const cancelToken = axios.CancelToken;
      const source = cancelToken.source();

      if (props.params.selectedItem?.value !== params.selectedItem?.value) {
         setParams(props.params)
         setLoaded(false); //for the spinner
      }
      api
         .postS('Inventory/InventoryVariance', payload, source.token)
         .then(response => {
            if (response.data.success) {
               const dataResponse = response.data.itemGrid.inventoryVariance
               setData(dataResponse);
               //set total here if its there
            } else {
               throw new Error(response);
            }
         })
         .catch(api.catchHandler)
         .finally(() => setLoaded(true));

      return () => {
         source.cancel("axios request cancelled");
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [props.params, includeLabels])

   return (
      <>
         <Card className="dashboard-card">
            <CardBody>
               <div>
                  <span className="h2" style={{ display: "inline" }}>Inventory Variance Adjustments Last 24 Months</span>
                  <div className="float-end InLineAttributes">
                     <div>
                        <Input
                           type="checkbox"
                           defaultChecked={false}
                           value={includeLabels}
                           onChange={() => setLWC(!includeLabels)}
                        />
                        {" "}
                        <span style={{ marginLeft: "10px" }}>Include Label Weight Changes?</span>
                     </div>
                  </div>
               </div>
               <hr />
               <ServiceThreadSpinner on={!loaded}>
                  {loaded && data.length !== 0 ?
                     <Table size="sm" className="data-table">
                        <thead className="table-header">
                           <tr>
                              <th style={{ width: "10%" }}>
                                 <SortHeader
                                    displayName={"Date"}
                                    field={"TransferDate"}
                                    sortDirection={props.sortDirection}
                                    sorted={props.sortField === "TransferDate"}
                                    callback={props.sortCallback}
                                    state={{
                                       invVarSortField: "TransferDate",
                                       invVarSortDirection: props.sortDirection === "asc" ? "desc" : "asc",
                                       typeOfDataSource: constants.INVENTORYDASHBOARD_TYPES.InventoryVariance,
                                    }}
                                 />
                              </th>
                              <th style={{ width: "10%" }}>
                                 <SortHeader
                                    displayName={"From"}
                                    field={"TransactionLocation"}
                                    sortDirection={props.sortDirection}
                                    sorted={props.sortField === "TransactionLocation"}
                                    callback={props.sortCallback}
                                    state={{
                                       invVarSortField: "TransactionLocation",
                                       invVarSortDirection: props.sortDirection === "asc" ? "desc" : "asc",
                                       typeOfDataSource: constants.INVENTORYDASHBOARD_TYPES.InventoryVariance,
                                    }}
                                 />
                              </th>
                              <th style={{ width: "10%" }}>
                                 <SortHeader
                                    displayName={"Quantity"}
                                    field={"TransactionQty"}
                                    sortDirection={props.sortDirection}
                                    sorted={props.sortField === "TransactionQty"}
                                    callback={props.sortCallback}
                                    state={{
                                       invVarSortField: "TransactionQty",
                                       invVarSortDirection: props.sortDirection === "asc" ? "desc" : "asc",
                                       typeOfDataSource: constants.INVENTORYDASHBOARD_TYPES.InventoryVariance,
                                    }}
                                 />
                              </th>
                              <th style={{ width: "10%" }}>
                                 <SortHeader
                                    displayName={"User"}
                                    field={"CreatedBy"}
                                    sortDirection={props.sortDirection}
                                    sorted={props.sortField === "CreatedBy"}
                                    callback={props.sortCallback}
                                    state={{
                                       invVarSortField: "CreatedBy",
                                       invVarSortDirection: props.sortDirection === "asc" ? "desc" : "asc",
                                       typeOfDataSource: constants.INVENTORYDASHBOARD_TYPES.InventoryVariance,
                                    }}
                                 />
                              </th>
                              <th style={{ width: "10%", fontWeight: "500" }}>Time</th>
                           </tr>
                        </thead>
                        <tbody>
                           {_.map(data, (datum, index) => {
                              return (
                                 <tr key={index} className={`tr-${index % 2 === 0 ? "primary" : "secondary"}`}>
                                    <td className="data-cell" children={dateHelpers.toLongDateString(datum.transferDate)} />
                                    <td className="data-cell" children={datum.transactionLocation} />
                                    <td className="data-cell" children={Math.round(datum.transactionQty).toLocaleString()} />
                                    <td className="data-cell" children={datum.createdBy} />
                                    <td className="data-cell" children={datum.transferTime?.slice(0, 5)} />
                                 </tr>
                              );
                           })}
                        </tbody>
                     </Table>
                     :
                     <div>
                        <span>No inventory variances found for the period</span>
                     </div>
                  }
               </ServiceThreadSpinner>
            </CardBody>
         </Card>
      </>
   );
}